module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal-popup-black', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowModal),
      expression: "isShowModal"
    }],
    attrs: {
      "title": _vm.$t("pop_ups.connect_your_open_id.title"),
      "text": _vm.$t("pop_ups.connect_your_open_id.text"),
      "textBtnPrimary": _vm.$t("pop_ups.connect_your_open_id.btns.primary"),
      "textBtnSecondary": _vm.$t("pop_ups.connect_your_open_id.btns.secondary")
    },
    on: {
      "eventBybtnPrimary": _vm.modalOk,
      "eventBybtnSecondary": _vm.modalClose,
      "eventBybtnCrissCross": _vm.modalCrissCross
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a8180a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tickets-and-bar/offer-use-open-id/index.vue
// module id = 417
// module chunks = 1